/* @ngInject */
const pieceIcons = () => {
  const self = {}

  self.name = 'train'
  self.quantity = 'train'
  self.sendingDate = 'train'
  self.sendingPlace = 'train'
  self.weight = 'train'

  return self
}
export default pieceIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/resources/icons.resource.js